/* eslint-disable prefer-destructuring */
import React, { useCallback, useEffect } from "react";
import _ from "lodash";
import { Input } from "design_system/src";
import useSkus from "hooks/useSkus";
import { SelectedSkuFilters } from "models/inventory/helpers/skuFilters.helpers";

interface Props {
  onChange: (changes: Partial<SelectedSkuFilters>) => void;
}

const SkuSearchInput: React.FC<Props> = ({ onChange }) => {
  const { selectedFilters: { searchText } = {} } = useSkus();
  const [text, setText] = React.useState(searchText ?? "");

  useEffect(() => {
    setText(searchText ?? "");
  }, [searchText]);

  const debouncedChange = useCallback(_.debounce((value: string) => {
    onChange({ searchText: value === "" ? undefined : value });
  }, 300), [onChange]);

  return (
    <div
      className="display_flex w_100_per"
      style={{ alignItems: "center", gap: 8, paddingLeft: 12, paddingRight: 12 }}
    >
      <Input
        title=""
        type="text"
        name="searchText"
        placeholder="Búsqueda"
        className="flex_1"
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          debouncedChange(e.target.value);
        }}
      />
    </div>
  );
};

export default SkuSearchInput;
